<template>
    <div class="flex-grow-1 d-flex flex-column">
        <div class="d-flex justify-content-between align-items-baseline">
            <span class="text-dark">
              {{ count }} Results
              <span class="font-weight-bold"
                    v-if="selectedCount > 0"
              >
                | {{ selectedCount }} selected
              </span>
            </span>
            <div class="d-flex justify-content-end mb-4">
                <b-dropdown
                        no-caret
                        right
                        variant="grey"
                        toggle-class="py-1 px-2"
                >
                    <template #button-content>
                        Actions
                        <font-awesome-icon
                                class="ml-1"
                                :icon="['fal', 'chevron-down']"
                                size="xs"
                        >
                        </font-awesome-icon>
                    </template>
                    <b-dropdown-item @click="onClickDownloadCsv">
                        <font-awesome-icon
                                :icon="['fal', 'download']"
                                size="sm"
                        >
                        </font-awesome-icon>
                        Download CSV
                    </b-dropdown-item>
                </b-dropdown>
                <refresh-button
                        @click="refresh"
                        :spinning="refreshing"
                        class="ml-3"
                >
                </refresh-button>
            </div>
        </div>
        <div class="flex-grow-1 d-flex">
            <ag-grid-vue
                    :style="'width: ' + gridWidth +'%;'"
                    class="ag-theme-balham"

                    :gridOptions="gridOptions"
                    :defaultColDef="defaultColDef"
                    :columnDefs="columnDefs"
                    :columnTypes="columnTypes"
                    :rowData="rowData"

                    rowSelection="single"

                    @gridReady="onGridReady"
                    :floatingFilter="floatingFilter"
                    :cacheQuickFilter="cacheQuickFilter"
                    :side-bar="sideBarDef"

                    :suppressExcelExport="suppressExcelExport"
                    :suppressContextMenu="true"

                    @cellClicked="onCellClicked"
                    :headerHeight="rowHeight"
                    :rowHeight="rowHeight"
            >
            </ag-grid-vue>
        </div>
    </div>
</template>

<script>
import {
  jobRemovedPropertyGridDefaultColDef as gridDefaultColDef,
  jobRemovedPropertyGridColumns as gridColumns,
  jobRemovedPropertyGridColumnTypes as columnTypes,
} from '@/services/Job/JobRemovedPropertyListingGrid';
import GridMixin from '@/components/Grid/GridMixin';
import Job from '@/services/Job/Job';
import dayjs from 'dayjs';
import RefreshButton from '@/components/Grid/RefreshButton';
import riskhub from "@/services/Riskhub/Riskhub";

export default {
  name: 'Job-Removed-Property-Grid',
  components: {
    RefreshButton,
  },
  mixins: [GridMixin],
  props: {
    job: {
      required: true,
      type: Object,
    },
    shown: {
      type: Boolean,
    },
  },
  data() {
    return {
      rowData: [],
      defaultColDef: gridDefaultColDef,
      columnDefs: gridColumns,
      columnTypes,
    };
  },
  watch: {
    shown() {
      this.gridApi.sizeColumnsToFit();
    },
  },
  methods: {
    postGridReady() {
      this.refresh();
    },
    async refresh() {
      this.refreshing = true;
      try {
        const { data } = await Job.getDeletedProperties(this.job.jobId);
        this.rowData = data.data;
      } finally {
        this.refreshing = false;
      }
    },
    onClickDownloadCsv() {
      const processCellCallback = (params) => {
        const column = params.column.getColId();
        let { value } = params;

        switch (column) {
          case 'numberRange':
          case 'streetNumber':
            if (value) {
              value = `="${value}"`;
            }
            break;

          case 'deletedDate':
            value = riskhub.formatDate(value, true) || 'N/A';
            break;
        }

        return value;
      };

      const params = {
        processCellCallback,
      };

      this.gridApi.exportDataAsCsv(params);
    },
  },
};
</script>

<style lang="scss">

</style>
